import { AUTH_PREFIX_PATH, REDIRECT_URL_KEY } from 'configs/AppConfig'

/**
 * Builds the login URL that brings the user back to `location` after signing in.
 * Keeps the query string so links like /app/settings/homepage?lang=pl survive the round-trip.
 */
export const buildLoginRedirectUrl = (loginPath, location) => {
	const target = `${location.pathname || '/'}${location.search || ''}`
	// Nothing to come back to: the root just forwards to the default entry page.
	if (target === '/') return loginPath
	return `${loginPath}?${REDIRECT_URL_KEY}=${encodeURIComponent(target)}`
}

/**
 * Reads `?redirect=` from a location search string and returns it only when it is a safe
 * in-app path; otherwise returns `fallback`. Rejects absolute URLs, protocol-relative URLs
 * (//evil.com), and auth pages (to avoid redirect loops).
 */
export const getSafeRedirect = (search, fallback) => {
	let value = null
	try {
		value = new URLSearchParams(search || '').get(REDIRECT_URL_KEY)
	} catch (e) {
		return fallback
	}
	if (!value) return fallback

	const isRelativePath = value.startsWith('/') && !value.startsWith('//') && !value.startsWith('/\\')
	if (!isRelativePath) return fallback
	if (value.startsWith(AUTH_PREFIX_PATH)) return fallback
	if (/^\/[^?#]*:/.test(value)) return fallback // e.g. "/javascript:..." style oddities

	return value
}
